import { useQuery } from '@tanstack/react-query';
import { getAllCustomers } from '@/lib/api/customers';
import type { Customer } from '@/contexts/auth/types';

/**
 * Lazily fetch the full customer list (the heavy ``GET /crm/customers/``
 * query). This MUST NOT run on general page load — the auth flow resolves
 * the active customer from the stored ``active_customer`` / a single
 * ``getCustomer(id)`` instead. The full list is only needed by the explicit
 * picker surfaces (``/select-customer``) and the topbar "Switch Customer"
 * menu, which gate the fetch with ``enabled``.
 *
 * @param enabled - when false the query is dormant and fires no request.
 */
export const useAllCustomers = (enabled: boolean) => {
  return useQuery<Customer[]>({
    queryKey: ['all-customers'],
    queryFn: ({ signal }) => getAllCustomers(signal),
    enabled,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
};
